module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetLow.d8dedad.jpg";